import { jsx as _jsx } from "react/jsx-runtime";
import RightBlueArrow from "../rightbluearrow";
import LeftBlueArrow from "../leftbluearrow";
import { Component } from "react";
const win = window;
export default class BackButton extends Component {
    constructor() {
        super(...arguments);
        this.handleSubmit = (event) => {
            event.preventDefault();
            this.props.onClick();
        };
    }
    render() {
        return (_jsx("div", Object.assign({ className: "showHand d-flex", onClick: this.handleSubmit }, { children: win["lang"] === "ar" ? (_jsx(RightBlueArrow, {}, void 0)) : (_jsx(LeftBlueArrow, {}, void 0)) }), void 0));
    }
}
